import React from 'react';
import { customers } from '../data/customers';

const Customers: React.FC = () => {
  return (
    <section id="partners" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-ink-900">
            Trusted by Leading Companies
          </h2>
          <p className="text-lg text-ink-500 max-w-2xl mx-auto">
            We're proud to partner with industry leaders worldwide
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center justify-items-center">
          {customers.map((customer) => (
            <a
              key={customer.id}
              href={customer.url}
              target="_blank"
              rel="noopener noreferrer"
              className="customer-logo w-full max-w-sm"
              aria-label={customer.name}
            >
              {customer.logo ? (
                customer.id === 'wd' ? (
                  <div className="w-full h-24 flex items-center justify-center bg-white rounded-lg border border-gray-200 shadow-sm">
                    <img
                      src={customer.logo}
                      alt={customer.name}
                      className="w-full h-full object-contain customer-logo"
                    />
                  </div>
                ) : (
                  <div className="w-full h-28 flex items-center justify-center bg-white rounded-lg border border-gray-200 px-6 py-4 shadow-sm">
                    <img
                      src={customer.logo}
                      alt={customer.name}
                      className="max-h-full max-w-full object-contain customer-logo"
                    />
                  </div>
                )
              ) : (
                <div className="w-full h-20 flex items-center justify-center bg-white rounded-lg border border-gray-200 shadow-sm">
                  <span className="text-lg font-semibold text-gray-800">{customer.name}</span>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Customers; 